import { RootState } from '../../store';

export const getDiscountById = (state: RootState) =>
  state.discounts?.discountById;

export const getDiscountInfo = (state: RootState) =>
  state.discounts?.discountInfo;

export const getSearchResults = (state: RootState) =>
  state.discounts.searchResults;

export const getRecentSearch = (state: RootState) =>
  state.discounts.recentSearch;

export const getSimilarDiscounts = (state: RootState) =>
  state.discounts.similarDiscounts;

export const getDiscountCategoryId = (state: RootState) =>
  state.discounts.discountById?.categories[0].id;

export const getDiscountsForMainPage = (state: RootState) =>
  state.discounts.discountsForMainPage;

export const getLatestDiscountsForMainPage = (state: RootState) =>
  state.discounts.latestDiscountsForMainPage;

export const isDiscountsLoading = (state: RootState) =>
  state.discounts.discountsIsLoading;

export const getDiscountsByCategory = (state: RootState) =>
  state.discounts.discountsByCategory;

export const getCurrentSortDirection = (state: RootState) =>
  state.discounts.currentSortDirection;

export const getCurrentSortField = (state: RootState) =>
  state.discounts.currentSortField;

export const getDiscountId = (state: RootState) =>
  state.discounts?.discountById?.id;

export const getDiscountCondition = (state: RootState) =>
  state.discounts?.discountById?.discountCondition;

export const getDiscountType = (state: RootState) =>
  state.discounts?.discountById?.discountType;

export const getType = (state: RootState) =>
  state.discounts?.discountById?.type;

export const getDiscountSizeMin = (state: RootState) =>
  state.discounts?.discountById?.sizeMin;

export const getDiscountSizeMax = (state: RootState) =>
  state.discounts?.discountById?.sizeMax;

export const getDiscountCompany = (state: RootState) =>
  state.discounts?.discountById?.company;

export const getDiscountCategories = (state: RootState) =>
  state.discounts?.discountById?.categories;

export const getDiscountImage = (state: RootState) =>
  state.discounts?.discountById?.imageDiscount;

export const getDiscountDateBegin = (state: RootState) =>
  state.discounts?.discountById?.dateBegin;

export const getDiscountDateFinish = (state: RootState) =>
  state.discounts?.discountById?.dateFinish;

export const getDiscountArea = (state: RootState) =>
  state.discounts?.discountById?.area;

export const getDiscountLikes = (state: RootState) =>
  state.discounts?.discountById?.likeCount;

export const getDiscountDislikes = (state: RootState) =>
  state.discounts?.discountById?.dislikeCount;
export const getRateType = (state: RootState) =>
  state.discounts?.discountById?.rateType;

export const getDiscountUserRating = (state: RootState) =>
  state.discounts?.discountById?.userRating;

export const getDiscountAverageRating = (state: RootState) =>
  state.discounts?.discountById?.averageRating;

export const getDiscountRatingCount = (state: RootState) =>
  state.discounts?.discountById?.ratingCount;

export const getDiscountName = (state: RootState) =>
  state.discounts?.discountById?.discountName;

export const getDiscountStatisticsSort = (state: RootState) =>
  state.discounts?.discountStatisticsState.sort;

export const getDiscountStatisticsFilters = (state: RootState) =>
  state.discounts?.discountStatisticsState.filters;

export const getDiscountIsArcived = (state: RootState) =>
  state.discounts?.discountById?.isArchived;

export const getDiscountStatus = (state: RootState) =>
  state.discounts?.discountById?.status;

export const getDiscountEditVersion = (state: RootState) =>
  state.discounts?.discountById?.editVersion;

export const getDiscountTimeCreate = (state: RootState) =>
  state.discounts?.discountById?.timeCreate;
